import React, { useCallback, useMemo } from 'react';
import { translate } from '@utils/i18n';
import { Radio, Loader } from '@ui';
import useAIInspectionManager from '../../hooks/useAIInspectionManager';
import useUpdateAIInspectionManager from '../../hooks/useUpdateAIInspectionManager';
const namespace = 'features.settings.ai_inspection_manager.workflow_mode';
function WorkflowModeTab() {
    var _a;
    const { data: settings, isLoading } = useAIInspectionManager();
    const { updateSettings } = useUpdateAIInspectionManager();
    const currentMode = (_a = settings === null || settings === void 0 ? void 0 : settings.iaMode) !== null && _a !== void 0 ? _a : 'tech_required';
    const options = useMemo(() => [
        {
            value: 'tech_required',
            label: (React.createElement("span", null,
                React.createElement("strong", null, translate('tech_required_label', { namespace })),
                React.createElement("br", null),
                React.createElement("span", { className: "advanced-settings-section__description" }, translate('tech_required_description', { namespace }))))
        },
        {
            value: 'tech_optional',
            label: (React.createElement("span", null,
                React.createElement("strong", null, translate('tech_optional_label', { namespace })),
                React.createElement("br", null),
                React.createElement("span", { className: "advanced-settings-section__description" }, translate('tech_optional_description', { namespace }))))
        },
        {
            value: 'backoffice_first',
            label: (React.createElement("span", null,
                React.createElement("strong", null, translate('backoffice_first_label', { namespace })),
                React.createElement("br", null),
                React.createElement("span", { className: "advanced-settings-section__description" }, translate('backoffice_first_description', { namespace }))))
        }
    ], []);
    const handleChange = useCallback((value) => {
        updateSettings.mutate({ settingsUpdate: { iaMode: value } });
    }, [updateSettings]);
    if (isLoading) {
        return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' } },
            React.createElement(Loader, { size: "48", title: "Loading", vertical: true })));
    }
    return (React.createElement("div", { className: "workflow-mode-tab" },
        React.createElement(Radio, { name: "workflow-mode", options: options, value: currentMode, onChange: handleChange })));
}
export default WorkflowModeTab;
